import React from 'react';
export default ({ fill, width = '100%', height = '100%'}) => (
	<svg fill={fill} x="0px" y="0px" width={width} height={height} viewBox="0 0 512 512" xmlSpace="preserve">
		<rect x="247.8" y="-78.4" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -105.6697 253.2243)" width="10" height="665.2"/>
    <rect x="-79.7" y="249.2" transform="matrix(0.7071 -0.7072 0.7072 0.7071 -105.6698 253.2485)" width="665.2" height="10"/>
	</svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/Close.js